import React from 'react'
import _ from 'lodash'
import immutable from 'immutable'


export class TravelSearchItem extends React.Component {
    constructor(props) {
  	super(props)

        let _isAdded = this.props.transportation.findIndex((trans) => {
            return trans.getIn(['transportation', 'transportation_guid']) === this.props.result.transportation_guid 
        })

        this.state = {
            isAdded: _isAdded > -1,
            showDetails: false
        }

        _.bindAll(this,
	      'addToItin',
	      'removeFromItin',
            'toggleDetails',
            'getDiagram'
	    )
    }

    componentDidReceiveProps(nextProps) {
        console.log('componentDidReceiveProps')
    }

    componentWillUpdate(nextProps, nextState) {
        console.log('componentWillUpdate')
    }

    addToItin() {
  	this.setState({isAdded: true})
        this.props.addTransportation(this.props.result)
    }

    removeFromItin() {
  	this.setState({isAdded: false})
        // We need it as an immutable and at this point it's still just a search result
        let tTrans = new immutable.fromJS(this.props.result)
        this.props.onRemoveTransportation(tTrans)
    }

    toggleDetails() {
        if (this.state.showDetails) {
            this.props.deActivateSearchItem()
            this.setState({showDetails: false})
        } else {
            this.props.activateSearchItem(this.props.result)      
            this.setState({showDetails: true})
        }
    }

    getDiagram() {
        let maxDuration = this.props.maxDuration // longest trip option for relative scale
        let totalDuration = this.props.result.totalDuration // this segments duration
        let totWidth = {width: totalDuration / maxDuration * 100 + '%'} // calculate this width relative to the longest route

        // let prevLeft = 0

        let diagram = this.props.result.segments.map((segment, index) => {
            let icon = 'icon-bike' // default?
            if (segment.vehicle && segment.vehicle.kind) {
                switch (segment.vehicle.kind) {
                    case 'plane':
                        icon = 'icon-plane'
                        break
                        break
                    case 'taxi':
                        icon = 'icon-car'
                        break
                }
            }

            let bandStyle = {width: (segment.transitDuration + segment.transferDuration) / totalDuration * 100 + '%'}
            return <div key={index} className="diagram-band" style={bandStyle}>
                <i className={icon}/>
            </div>
        })
        return (
            <div className="travel-detail-diagram" style={totWidth}>
                {diagram}
            </div>
        )
    }

    render() {
        let activeButton = this.state.isAdded ? <a onClick={this.removeFromItin} className="btn btn-rose btn-flex">Saved <i className="icon-favorite_selected"/></a> : <a onClick={this.addToItin} className="btn btn-rose btn-flex">Save <i className="icon-favorite"/></a>
        let detailsLabel = this.state.showDetails ? 'Hide Details' : 'Show Details'

        let price = this.props.result.indicativePrices && this.props.result.indicativePrices[0].priceLow ? 'starting at $' + this.props.result.indicativePrices[0].priceLow : 'price unavailable'

        return (
            <div className="travel-option-row">
                <div className="row">
                    <div className="col-sm-9">
                        <div className="row">
                            <div className="col-sm-8">
                                <h1>{this.props.result.name}</h1>
                                <div className="travel-result-duration">{this.props.getDuration(this.props.result.totalDuration)}</div>
                            </div> 
                            <div className="col-sm-4">
                                <div className="travel-result-price">{price}</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="travel-detail-block">
                                { this.getDiagram() }
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3">
                        {activeButton}
                        <a onClick={() => this.toggleDetails()} className="btn btn-plain">{detailsLabel}</a>
                    </div>
                </div>
            </div>
        )
    }
}
